import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import homepage from '@/components/HomePage/homepage'
import notice from '@/components/NotiDeclare/notice'
import notilist from '@/components/NotiDeclare/notilist'
import policy from '@/components/PreferentPolicy/policy'
import polidetail from '@/components/PreferentPolicy/polidetail'
import bshow from '@/components/BusinessShow/bshow'
import bsdetail from '@/components/BusinessShow/bsdetail'
import notidetail from '@/components/NotiDeclare/notidetail'
import detail from '@/components/NotiDeclare/detail'
import declare from '@/components/NotiDeclare/declare'
import declare2 from '@/components/NotiDeclare/declare2'
import user from '@/components/user/index'
import usercenter from '@/components/user/usercenter'
import userproject from '@/components/user/userproject'
import usersurvey from '@/components/user/usersurvey'
import usersurvey2 from '@/components/user/usersurvey2'
import userappeal from '@/components/user/userappeal'
import uservisit from '@/components/user/uservisit'
import userfav from '@/components/user/userfav'
import userfav2 from '@/components/user/userfav2'
import userset from '@/components/user/userset'
import usermanage from '@/components/user/usermanage'
import addus from '@/components/user/form/addus'
import addappeal from '@/components/user/form/addappeal'
import addvisit from '@/components/user/form/addvisit'
import addsurvey from '@/components/user/form/addsurvey'
import addsurvey2 from '@/components/user/form/addsurvey2'
import editvisit from "../components/user/form/editvisit"
import editsurvey from "../components/user/form/editsurvey"
import editsurvey2 from "../components/user/form/editsurvey2"
import userclfx from '@/components/user/leaveFX.vue'
import userclfx2 from '@/components/user/comeToFX.vue'


Vue.use(Router)


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    routes: [
        {path: '/', name: 'index', component: index, children: [
            {name: 'homepage', path: '', component: homepage},
            {name: 'notice', path: '/notice', component: notice, children: [
                {name: 'notilist', path: '/', component: notilist},
                {name: 'notidetail', path: '/notidetail', component: notidetail},
                {name: 'declare', path: '/declare', component: declare},
                {name: 'declare2', path: '/declare2', component: declare2}
            ]},
            {name: 'policy', path: '/policy', component: policy},
            {name: 'polidetail', path: '/polidetail', component: polidetail},
            {name: 'bshow', path: '/bshow', component: bshow},
            {name: 'bsdetail', path: '/bsdetail', component: bsdetail},
            {name: 'user', path: '/user', component: user, children: [
                {name: 'usercenter', path: '', component: usercenter},
                {name: 'userproject', path: '/userproject', component: userproject},
                {name: 'usersurvey', path: '/usersurvey', component: usersurvey},
                {name: 'usersurvey2', path: '/usersurvey2', component: usersurvey2},
                {name: 'userappeal', path: '/userappeal', component: userappeal},
                {name: 'uservisit', path: '/uservisit', component: uservisit},
                {name: 'userfav', path: '/userfav', component: userfav},
                {name: 'userfav2', path: '/userfav2', component: userfav2},
                {name: 'userset', path: '/userset', component: userset},
                {name: 'usermanage', path: '/usermanage', component: usermanage},
                {name: 'userclfx', path: '/userclfx', component: userclfx},
                {name: 'userclfx2', path: '/userclfx2', component: userclfx2}
            ]}]
        },
        {name: 'addus', path: '/addus', component: addus},
        {name: 'addappeal', path: '/addappeal', component: addappeal},
        {name: 'addvisit', path: '/addvisit', component: addvisit},
        {name: 'addsurvey', path: '/addsurvey', component: addsurvey},
        {name: 'addsurvey2', path: '/addsurvey2', component: addsurvey2},
        {name: 'adddeclare', path: '/adddeclare', component: declare},
        {name: 'adddeclare2', path: '/adddeclare2', component: declare2},
        {name: 'detail', path: '/detail', component: detail},
        {name: 'editvisit', path: '/editvisit', component: editvisit},
        {name: 'editsurvey', path: '/editsurvey', component: editsurvey},
        {name: 'editsurvey2', path: '/editsurvey2', component: editsurvey2}
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js